<template>
    <div>
        <tab name="2"></tab>
        <el-alert type="warning" title="工作人员操作规范" :closable="false">
            <div>1、<b>与用户确认是否用户本人操作</b>人脸验证，确认用户本人操作，若当前剩余人脸验证次数等于“0”，<b>重置验证次数，让用户再次尝试</b>。</div>
            <div>2、在<b>保证用户本人按规操作</b>的情况下，<b>若多次人脸均失败</b>，请立即与技术<b>确认是否因用户自身信息问题</b>导致无法通过人脸审核。</div>
            <div>3、确认因用户自身信息问题导致无法通过人脸审核。<b>要求用户提供手持证件照，确定是用户本人操作。</b>可使用【跳过人脸验证】功能跳过验证环节。</div>
            <div>4、操作【跳过人脸验证】后，若<b>用户反馈仍然看不到入场码</b>。可能因为用户卸载应用、或更换过手机，设备号发生改变，此时<b>调整人脸验证次数为“3”，确认用户在最新使用的设备</b>上至少<b>尝试一次人脸验证</b>，然后<b>【刷新跳过人脸状态】再操作【跳过人脸验证】</b>。</div>
            <div>注意：因用户<b>改名、或观演人信息有误</b>提示“实名校验不通过”等问题。如需修改观演人信息，可在<b>订单详情中修改观演人</b>。</div>
        </el-alert>
        <div class="page-filter-box MT10">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8">
                    <el-input placeholder="请输入证件号" v-model="params.documentNumber" size="small">
                    </el-input>
                </el-col>
                <el-col :sm="12" :md="8" :lg="8" :xl="4" >
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>					
                </el-col>
            </el-row>
        </div>
        <el-card class="info-group" v-if="data">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8">
                    <span class="color-info">用户身份证号：</span>{{data.documentNumber}}
                </el-col>
                <!-- <el-col :xs="24" :sm="12" :md="8">
                    <span class="color-info">用户姓名：</span>{{ data && data.documentName}}
                </el-col> -->
                <el-col :xs="24" :sm="12" :md="8">
                    <span class="color-info">用户剩余人脸验证次数：</span><b>{{data.authNum || 0}}</b>次
                    <el-button 
                        v-if="$utils.have('/commonPerformer/resetFaceNum')" 
                        type="text" 
                        size="mini"
                        @click="$refs.resetFaceNum.show(data)">
                        调整人脸次数为“3”</el-button>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8">
                    <span class="color-info">工作人员操作调整次数：</span><b>{{data.updateNum || 0}}</b>次
                </el-col>
                <el-col :xs="24">
                    <span class="color-info">跳过人脸状态：</span>
                    <span v-if="data.skipDeviceId">当前已跳过（设备号：{{data.skipDeviceId}}）</span>
                    <span v-else>未跳过 </span>
                    <span v-if="data.isChange" class="color-danger">用户最近验证人脸的设备发生变化 </span>
                    <el-button 
                        v-if="(!data.skipDeviceId || data.isChange) && $utils.have('/commonPerformer/skipFaceAuth')" 
                        type="text" 
                        size="mini" 
                        @click="$refs.skipFaceAuth.show(data)">
                        跳过人脸验证</el-button>
                </el-col>
            </el-row>
        </el-card>
        <div class="page-list-box">
            <el-table
                :data="dataList && dataList.result"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="updateTime" label="最近操作时间" min-width="150"></el-table-column>
				<el-table-column prop="platform" label="验证平台">
					<template slot-scope="scope">
					    <span v-if="scope.row.platform == 1">阿里云</span>					    
					    <span v-else>腾讯云</span>
					</template>
				</el-table-column>				
                <el-table-column prop="documentName" label="人脸验证人" min-width="100" show-overflow-tooltip></el-table-column>
                <el-table-column prop="documentNumber" label="人脸验证人身份证号" min-width="160"></el-table-column>
                <el-table-column prop="status" label="验证结果">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 0">新建</span>
                        <span v-else-if="scope.row.status == 1" class="color-success">通过</span>
                        <span v-else-if="scope.row.status == 2" class="color-danger">未通过</span>
                        <span v-else>其他</span>
                    </template>
                </el-table-column>
                <el-table-column prop="reason" label="原因" show-overflow-tooltip min-width="120"></el-table-column>
                <el-table-column prop="prompts" label="建议处理方法" show-overflow-tooltip min-width="120"></el-table-column>
				<el-table-column prop="certifyId" label="认证ID" show-overflow-tooltip min-width="120"></el-table-column>				
                <el-table-column prop="deviceId" label="登录设备号" show-overflow-tooltip min-width="100"></el-table-column>
                <el-table-column prop="terminal" label="操作终端"></el-table-column>
                <el-table-column prop="userId" label="账号ID" ></el-table-column>
                <el-table-column prop="accountStatus" label="账号状态" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.accountStatus == 1" class="color-success">正常</span>
                        <span v-else>注销</span>
                    </template>
                </el-table-column>
                <el-table-column prop="telephone" label="登录账号" min-width="110"></el-table-column>
                <el-table-column prop="authName" label="账号实名人姓名" min-width="110" show-overflow-tooltip></el-table-column>
                <el-table-column prop="authNumber" label="账号实名人身份证号" min-width="160"></el-table-column>
            </el-table>
        </div>
        <div v-if="dataList" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="dataList.totalCount || 0">
            </el-pagination>
        </div>

        <SkipFaceAuth ref="skipFaceAuth" @onUpdate="getDataList"></SkipFaceAuth>
		<ResetFaceNum ref="resetFaceNum" @onUpdate="getDataList"></ResetFaceNum>
    </div>
</template>
<script>
import Tab from './components/tab';
import SkipFaceAuth from './components/skipFaceAuth';
import ResetFaceNum from './components/resetFaceNum';
const defaultParams = {
    pageNo:1,
    documentNumber: ''
}
export default {
    components:{Tab,SkipFaceAuth,ResetFaceNum},
    data(){
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo:parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                documentNumber: this.$route.query.documentNumber || ""
            },
            listLoading: false,    
        }
    },
    mounted(){
        if( this.params.documentNumber ){
            this.getDataList();
        }
    },
    methods:{
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.params = {
                ...this.params,
            }
            this.$request({
                url: "/commonPerformer/authList",
                method: "POST",
                params: this.params,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = this.params.pageNo == 1 ? result : this.data;
                        this.dataList = result.authList || null;
                    } else {
                        this.data = null;
                        this.dataList = null;
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.data = null;
                    this.dataList = null;
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
    }
}
</script>

<style lang="scss" scoped>
.el-alert{
    .el-alert__content{
        div{
            margin-top: 5px;
        }
    }
    b{
        // font-weight: 700;
        color: $--color-danger;
    }
}

.info-group{
    line-height: 30px;
    b{
        font-size: 20px;
    }
}
</style>